<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setDialogFilter(true)"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible="dialog_filter"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogFilter(false)"
    >
      <el-input type="text" v-model="title" placeholder="Title" clearable />
      <el-input type="text" v-model="videoId" placeholder="Video Id" class="mt10" clearable />
      <el-date-picker
          style="width: 100%; margin-top: 15px"
          v-model="createdAt"
          type="date"
          placeholder="Created at date"
          :value-format="'yyyy-MM-dd'"
          format="d MMMM yyyy">
      ></el-date-picker>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      title: '',
      videoId: '',
      createdAt: ''
    }
  },
  computed: {
    ...mapState('youtubeClaimLog', ['dialog_filter'])
  },
  methods: {
    ...mapMutations('youtubeClaimLog', ['setDialogFilter', 'setFilter', 'setPage']),
    ...mapActions('youtubeClaimLog', ['getDetails']),

    filter() {
      this.setFilter({
        title: this.title,
        videoId: this.videoId,
        createdAt: this.createdAt
      })
      this.setPage(1)
      this.getDetails()
      this.setDialogFilter(false)
    },

    clear() {
      this.setFilter({})
      this.getDetails()
      this.title = ''
      this.videoId = ''
      this.createdAt = ''
      this.setDialogFilter(false)
    }
  }
}
</script>
